import { ElementRef, WritableSignal } from "@angular/core";
import { SlideType } from "library-explorer";
import { SlideDTO } from "@app/model/slideDTO.model";
import { SlideBuilderComponent } from "../slide-builder/slide-builder.component";


export abstract class BaseSlideWidgetComponent {
  public abstract slideBuilderComponent: SlideBuilderComponent;
  public abstract data: SlideDTO;
  public abstract slideHidden: WritableSignal<boolean>;

  private readonly animationClassesList = ['animate__animated', 'animate__bounce', 'animate__repeat-2'];

  private intersectionObserver: IntersectionObserver | null = null;

  constructor(protected readonly element: ElementRef) {
  }

  public indicateInteractionNotCompleted(slidesIds: string[] = []): void {
    this.element.nativeElement.classList.remove(...this.animationClassesList);

    if (this.data.bundle === SlideType.SlideBuilder) {
      const slides = this.slideBuilderComponent.getSlideWidgets();
      slides.forEach(slide => slide.indicateInteractionNotCompleted(slidesIds));
      return;
    }

    const interactionCompleted = slidesIds.indexOf(this.data.id) === -1;
  
    if (interactionCompleted) {
      return;
    }

    setTimeout(() => {
      this.element.nativeElement.classList.add(...this.animationClassesList);
    });
  }

  protected addIntersectionObserver(): void {
    setTimeout(() => {
      const maxThresholdPx = 100;
      const minThresholdRatio = .01;
      let threshold = .1;

      const height = this.element?.nativeElement?.offsetHeight || 0;

      const thresholdInPx = height * threshold;
      
      if (thresholdInPx > 100) {
        threshold = Math.round(100 * maxThresholdPx / height) / 100;
        threshold = Math.max(threshold, minThresholdRatio);
      }

      this.intersectionObserver = new IntersectionObserver((entries, { }) => {
        const entry = entries.length && entries[0];
        this.slideHidden.set(entry ? entry.intersectionRatio < threshold : false);
      }, { threshold: [threshold] });

      this.intersectionObserver.observe(this.element.nativeElement);
    }, 100);
  }

  protected removeIntersectionObserver(): void {
    this.intersectionObserver?.disconnect();
    this.intersectionObserver = null;
  }
}